import { View, Text, StyleSheet } from "react-native";
import { useAppConfig } from "../../../AppConfigProvider";

function UserInitial({ initial, type }) {
  const { primaryColor } = useAppConfig();

  const isMenu = type === "menu";

  const containerStyle = [
    styles.container,
    isMenu
      ? {
          background: "linear-gradient(95deg, #3e68fe -26%, #913daf 129.04%)",
          backgroundColor: "#d9d9d9",
          height: 36,
          width: 36,
          borderRadius: 24,
        }
      : {
          backgroundColor: primaryColor,
        },
  ];

  const textStyle = [
    styles.text,
    isMenu && {
      color: "#fff",
      fontSize: 20,
      lineHeight: 24,
    },
  ];

  return (
    <View style={containerStyle}>
      <Text style={textStyle}>{initial}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 24,
    width: 24,
    borderRadius: 12,
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    color: "#fff",
    fontSize: 14,
    fontWeight: "bold",
  },
});

export default UserInitial;
